import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ClickHandler = () => {
    window.scrollTo(10, 0);
};

const CtaSection = () => {
    const { t } = useTranslation();

    return (
        <section className="wpo-cta-section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="wpo-cta-text">
                            <span>{t('cta.title')}</span>
                            <p>{t('cta.text')}</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="wpo-cta-btn">
                            <Link onClick={ClickHandler} className="theme-btn-s2" to="/contact">{t('cta.button')}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaSection;
